module.exports = __webpack_public_path__ + "assets/people_black_24dp.svg";